export default "__VITE_ASSET__Demiu8Ak__"